<script>
  import { ToastNotification } from "carbon-components-svelte";
  import { fly } from "svelte/transition";

  import { toast } from "../stores/toastStore.js";

  $: show = $toast.message !== "";
  $: saveSuccessful = $toast.type === "success";
</script>

{#if show}
  <div
    in:fly={{ x: 100 }}
    out:fly={{ y: 100 }}
    style="position:absolute; top:60px; right:20px; z-index:4000;"
  >
    <ToastNotification
      hideAfter={saveSuccessful ? 3000 : null}
      timeout={saveSuccessful ? 3000 : null}
      kind={saveSuccessful ? "success" : "error"}
      title={$toast.title || (saveSuccessful ? "Success" : "Error")}
      subtitle={$toast.message}
      fullWidth
      caption={new Date().toLocaleString()}
      on:close={(event) => {
        event.preventDefault();
        toast.hideToast();
      }}
    />
  </div>
{/if}
